import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state() {
    return {
      cardTransactions: [],
      cardPage: {
        page: 0,
        size: 10,
        totalPages: 0,
        totalElements: 0
      }
    };
  },
  actions,
  getters,
  mutations
};
